import { useState } from "react";
import { api } from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import { toast } from "sonner";
import { PaperPlaneTilt } from "@phosphor-icons/react";

export default function WebsiteSimulator() {
  const [order, setOrder] = useState({
    website_order_id: `WEB-${Date.now()}`,
    idempotency_key: `idem-${Date.now()}`,
    customer: { name: "Ishaan Patel", phone: "+91 98999 66601", email: "ishaan@example.com" },
    billing_address: { line1: "17 Colaba Causeway", city: "Mumbai", state: "Maharashtra", pin: "400005", country: "India" },
    shipping_address: { line1: "17 Colaba Causeway", city: "Mumbai", state: "Maharashtra", pin: "400005", country: "India" },
    items: [{ sku: "AE-BG-002-TAN", name: "Editorial Structured Tote", size: "OneSize", colour: "Tan", quantity: 1, unit_price: 12400 }],
    subtotal: 12400, discount: 0, tax_total: 2232, shipping_charge: 0, total: 14632, currency: "INR",
    payment_mode: "razorpay", payment_status: "confirmed", payment_reference: "rzp_test_SIM",
  });
  const [exchange, setExchange] = useState({ website_order_id: "", reason: "size_issue", written_explanation: "The M was tight around the sleeves, need L.", item: { sku: "AE-AP-001-BLK-S", size: "M", colour: "Ivory", quantity: 1 }, customer: { name: "Meera Iyer", email: "meera@example.com" }, product_photos: ["https://images.pexels.com/photos/7450781/pexels-photo-7450781.jpeg"], damage_photos: [] });
  const [response, setResponse] = useState(null);

  const sendOrder = async () => {
    try {
      const { data } = await api.post("/integration/webhook/order", order);
      setResponse(data); toast.success(data.duplicate ? `Duplicate blocked · ${data.order_number}` : `Received · ${data.order_number}`);
    } catch (e) { toast.error(e?.response?.data?.detail || "Failed"); setResponse(null); }
  };

  const sendExchange = async () => {
    try {
      const { data } = await api.post("/integration/webhook/exchange", exchange);
      setResponse(data); toast.success(`Exchange received · ${data.exchange_number}`);
    } catch (e) { toast.error("Failed"); }
  };

  const newIdem = () => setOrder({ ...order, idempotency_key: `idem-${Date.now()}`, website_order_id: `WEB-${Date.now()}` });

  return (
    <div data-testid="simulator-page" className="page-fade">
      <PageHeader eyebrow="Testing" title="Website simulator" description="Simulate webhooks the customer-facing website would send to the ERP. Useful for validating flows without touching production." />
      <div className="grid lg:grid-cols-2 gap-5">
        <div className="card-elevated">
          <div className="flex items-center justify-between">
            <div>
              <div className="label-eyebrow">POST /api/integration/webhook/order</div>
              <div className="display-3 mt-1">Order webhook</div>
            </div>
            <button onClick={newIdem} className="btn-ghost btn-sm" data-testid="sim-new-idem">New idem key</button>
          </div>
          <textarea
            className="textarea-soft mt-5 font-mono text-xs min-h-[300px]"
            value={JSON.stringify(order, null, 2)}
            onChange={(e) => { try { setOrder(JSON.parse(e.target.value)); } catch (_) { /* invalid JSON */ } }}
            data-testid="sim-order-json"
          />
          <button onClick={sendOrder} className="btn-primary w-full mt-4" data-testid="sim-send-order"><PaperPlaneTilt size={14}/> Send order webhook</button>
          <p className="mt-3 text-[11px] text-muted-foreground">Reuse the same idempotency key to test duplicate blocking.</p>
        </div>
        <div className="card-elevated">
          <div className="label-eyebrow">POST /api/integration/webhook/exchange</div>
          <div className="display-3 mt-1">Exchange webhook</div>
          <textarea
            className="textarea-soft mt-5 font-mono text-xs min-h-[300px]"
            value={JSON.stringify(exchange, null, 2)}
            onChange={(e) => { try { setExchange(JSON.parse(e.target.value)); } catch (_) { /* invalid JSON */ } }}
            data-testid="sim-exchange-json"
          />
          <button onClick={sendExchange} className="btn-primary w-full mt-4" data-testid="sim-send-exchange"><PaperPlaneTilt size={14}/> Send exchange webhook</button>
        </div>
      </div>
      {response && (
        <div className="mt-6 card-elevated" data-testid="sim-response">
          <div className="label-eyebrow">Response</div>
          <pre className="mt-3 font-mono text-xs whitespace-pre-wrap bg-muted/40 rounded-lg p-4 border border-border/60">{JSON.stringify(response, null, 2)}</pre>
        </div>
      )}
    </div>
  );
}
